import '~/js/modules/section-hero';
import 'slick-carousel';

// Family Suites slider options
const $sliderFamilySuites = $('.js-slick-slider-family-suites');

$sliderFamilySuites.slick({
  prevArrow: $('.js-family-suites-prev'),
  nextArrow: $('.js-family-suites-next'),
  dots: false,
  appendDots: $('.js-family-suites-append-dots'),
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true
      }
    }
  ]
});

// Seaside Villas slider options
const $sliderSeasideVillas = $('.js-slick-slider-seaside-villas');

$sliderSeasideVillas.slick({
  prevArrow: $('.js-seaside-villas-prev'),
  nextArrow: $('.js-seaside-villas-next'),
  dots: false,
  appendDots: $('.js-seaside-villas-append-dots'),
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true
      }
    }
  ]
});

// Penthouse Suites slider options
const $sliderPenthouseSuites = $('.js-slick-slider-penthouse-suites');

$sliderPenthouseSuites.slick({
  prevArrow: $('.js-penthouse-suites-prev'),
  nextArrow: $('.js-penthouse-suites-next'),
  dots: false,
  appendDots: $('.js-penthouse-suites-append-dots'),
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true
      }
    }
  ]
});

// Tranquility slider options
const $sliderTranquility = $('.js-slick-slider-tranquility');

$sliderTranquility.slick({
  prevArrow: $('.js-tranquility-prev'),
  nextArrow: $('.js-tranquility-next'),
  dots: false,
  appendDots: $('.js-tranquility-append-dots'),
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true
      }
    }
  ]
});


function redirectToPage(select) {
  if (select.value) {
    window.location.href = select.value;
  }
}